module.exports = __webpack_public_path__ + "static/media/signup-avatar-type.6a3c13cd.png";